import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";

export class KarenGameIntroPlugin extends NolimitGameIntroPlugin {
    getReady(): Promise<NolimitPlugin> {
        return super.getReady().then((value: NolimitPlugin) => {
            this._view.addChild(this._view.children[1]);
            return value;
        });
    }
}
